import type { HttpInterceptorFn } from '@angular/common/http';
import { ErrorHandler, PLATFORM_ID, inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { withoutQueryString } from '@app/core/errors/error-report.util';
import { isHttpErrorResponse, toProblemDetails } from '@app/core/errors/problem-details.util';
import { expireSession } from '@app/core/session/session-expiry.util';
import { SessionStore } from '@app/core/session/session-store';

import type { ProblemDetailsDto } from '@app/core/errors/problem-details.types';

const UNEXPECTED_ERROR_MESSAGE = 'Ocorreu um erro inesperado.';

const UNAUTHORIZED = 401;

class SessionExpiredError extends Error {
  constructor(path: string) {
    super(`sessão encerrada por 401 em ${path}`);
    this.name = 'SessionExpiredError';
  }
}

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const sessionStore = inject(SessionStore);
  const platformId = inject(PLATFORM_ID);
  const errorHandler = inject(ErrorHandler);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (!isHttpErrorResponse(error)) {
        const problemDetails: ProblemDetailsDto = { title: 'Erro', detail: UNEXPECTED_ERROR_MESSAGE, extensions: {} };

        return throwError(() => problemDetails);
      }

      const httpError = error;

      if (httpError.status === UNAUTHORIZED && expireSession(sessionStore, platformId)) {
        errorHandler.handleError(new SessionExpiredError(withoutQueryString(httpError.url ?? '(sem url)')));
      }

      return throwError(() => toProblemDetails(httpError.error) ?? httpError);
    }),
  );
};
